import { dbUser } from 'dbServer/collections';

export const attemptCreateUser = newUser => {
	return dbUser.doCreateUser(newUser.uid, newUser);
};

export const attemptUpdateUser = (userId, data) => dbUser.doUpdateUser(userId, data);
export const fetchUserInfo = userId => dbUser.getUser(userId);
